import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import meetingIcon from "../../../assets/agent/meeting.svg";
import meetingRecoveryIcon from "../../../assets/agent/recovery.svg";
import followUpIcon from "../../../assets/agent/followUp.svg";
import coldCallsIcon from "../../../assets/agent/coldCalls.svg";

const AgentHeader = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const user = sessionStorage.getItem("userName");
  const clientName = sessionStorage.getItem("clientName");
  const recovery = location.pathname === "/agent/meeting-recovery";
  const meeting = location.pathname === "/agent/meeting";
  const followUp = location.pathname === "/agent/follow-up";
  const coldCalls = location.pathname === "/agent/cold-calls";

  return (
    <div className="mb-3">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between p-4 rounded-lg space-y-4 md:space-y-0">
        <div className="flex-1">
          <h1 className="text-lg md:text-[1.5rem] font-bold">
            {t("dashboard.greeting", { name: user })}
          </h1>
          <p className="text-sm md:text-[1.4rem] text-primary w-full md:w-[450px] mb-2">
            {t("agent.head")}
            <span className="font-semibold">{clientName}</span>
          </p>
        </div>
        {recovery ? (
          <div className="flex gap-2 items-center justify-center">
            <img
              src={meetingRecoveryIcon}
              alt="meetingRecoveryIcon"
              className="w-5 h-5 [filter:brightness(0)_saturate(100%)_invert(12%)_sepia(22%)_saturate(2103%)_hue-rotate(191deg)_brightness(96%)_contrast(98%)]"
            />
            <span className="text-lg font-bold text-primary">
              {t("agent.cards.MeetingRecovery")}
            </span>
          </div>
        ) : meeting ? (
          <div className="flex gap-2 items-center justify-center">
            <img
              src={meetingIcon}
              alt="meeting"
              className="w-5 h-5 [filter:brightness(0)_saturate(100%)_invert(12%)_sepia(22%)_saturate(2103%)_hue-rotate(191deg)_brightness(96%)_contrast(98%)]"
            />
            <span className="text-lg font-bold text-primary">
              {t("agent.cards.Meeting")}
            </span>
          </div>
        ) : followUp ? (
          <div className="flex gap-2 items-center justify-center">
            <img
              src={followUpIcon}
              alt="followUp"
              className="w-5 h-5 [filter:brightness(0)_saturate(100%)_invert(12%)_sepia(22%)_saturate(2103%)_hue-rotate(191deg)_brightness(96%)_contrast(98%)]"
            />
            <span className="text-lg font-bold text-primary">
              {t("agent.cards.FollowUp")}
            </span>
          </div>
        ) : coldCalls ? (
          <div className="flex gap-2 items-center justify-center">
            <img
              src={coldCallsIcon}
              alt="coldCalls"
              className="w-5 h-5 [filter:brightness(0)_saturate(100%)_invert(12%)_sepia(22%)_saturate(2103%)_hue-rotate(191deg)_brightness(96%)_contrast(98%)]"
            />
            <span className="text-lg font-bold text-primary">
              {t("agent.cards.coldCalls")}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="relative flex items-center">
        <span className="absolute left-0 w-1 h-1 bg-[#0A1E4C] rounded-full -ml-1"></span>
        <hr className="flex-1 border-t-2 border-[#0A1E4C]" />
        <span className="absolute right-0 w-1 h-1 bg-[#0A1E4C] rounded-full -mr-1"></span>
      </div>
    </div>
  );
};

export default AgentHeader;
